import React from "react";
import AuctionSummaryLoginSvg from "../../../icons/AuctionSummaryLoginSvg";
import UpcomingActionLoginSvg from "../../../icons/UpcomingActionLoginSvg";

export default function SellerLoginHero() {
  return (
    <div className="w-full lg:w-1/2 h-full text-center md:text-left flex flex-col justify-center">
      <p className="font-normal text-login-color font-primary uppercase text-3xl mid:text-[40px] lg:text-[53px] leading-tight hidden lg:block">
        Simply manage your
      </p>
      <p className="uppercase font-primary font-normal text-3xl mid:text-[40px] lg:text-[53px] text-login-color hidden lg:block">
        auctions
      </p>
      <p className="uppercase font-primary font-normal text-2xl lg:hidden text-login-color text-left">
        Simply manage your auctions
      </p>
      <div className="flex justify-center lg:justify-start mt-6 lg:mt-8">
        <div className="relative w-[260px] h-[210px] mid:w-[320px] mid:h-[260px] lg:w-[360px] lg:h-[300px] flex justify-center">
          <UpcomingActionLoginSvg className="shadow-2xl ml-0 mr-6 mid:mr-0 mid:ml-6 h-[150px] mid:h-[190px] lg:h-[210px]" />
          <div className="absolute right-0 mid:right-10 lg:right-16 top-16 mid:top-24 lg:top-24">
            <AuctionSummaryLoginSvg className="shadow-2xl h-[90px] mid:h-[150px] lg:h-[190px] w-[90px] mid:w-[150px] lg:w-[190px]" />
          </div>
        </div>
      </div>
    </div>
  );
}

